/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { PidxInlineFormMessagesModule } from './components/pidx-inline-form-messages/pidx-inline-form-messages.module'
import { PidxLoaderModule } from './components/pidx-loader/pidx-loader.module'
import { PidxPdsModalWrapperModule } from './components/pidx-pds-modal-wrapper/pidx-pds-modal-wrapper.module'
import { PidxSkeletonLoaderModule } from './components/pidx-skeleton-loader/pidx-skeleton-loader.module'
import { PidxTimerLabelModule } from './components/pidx-timer-label/pidx-timer-label.module'

@NgModule({
  imports: [CommonModule],
  exports: [
    PidxLoaderModule,
    PidxSkeletonLoaderModule,
    PidxPdsModalWrapperModule,
    PidxTimerLabelModule,
    PidxInlineFormMessagesModule,
  ],
})
export class PidxUiComponentsModule {}
